import * as Yup from "yup";
import { Gender } from "lib/models/client/LowTaxBroker/CitizenshipData";

export const MajorityShareholderCitizenshipInformationSchema = (t) =>
  Yup.object().shape({
    gender: Yup.string().oneOf(Object.values(Gender)).required(t("generic:validation-required")),
    birthDate: Yup.string().required(t("generic:validation-required")),
    birthCity: Yup.string().required(t("generic:validation-required")),
    birthCountry: Yup.string().required(t("generic:validation-required")),
    citizenship: Yup.string().required(t("generic:validation-required")),
    secondCitizenship: Yup.string().nullable(),
    notUSCitizenOrTaxResident: Yup.boolean().required(t("generic:validation-required"))
  });
